import Api from './api.service'

export default {
  createCategory (object) {
    return Api().post('newsCategory/create', object)
  },
  deleteCategory (id) {
    return Api().delete('newsCategory/delete/' + id)
  },
  getCategory (id) {
    return Api().get('newsCategory/get/' + id)
  },
  getCategoryList () {
    return Api().post('newsCategory/list')
  },
  updateNewsCategory (object) {
    return Api().put('newsCategory/edit/' + object.id, object.object)
  }
}